import * as yup from "yup";
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-])|(\\([0-9]{2,3}\\)[ \\-])|([0-9]{2,4})[ \\-])?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const addcategary = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    gender: yup.number().required("This field is required"),
    position: yup
      .number()
      .required("This field is required")
      .typeError("This field is required"),
    status: yup
      .number()
      .oneOf(
        [1, 2, 3, 4],
        "Status must be 1 (Active), 2 (Inactive), 3 (Blocked), or 4 (Deleted)"
      )
      .required("This field is required"),
    home_view: yup.string().required("This field is required"),
  });

export const addcategary1 = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    gender: yup
      .number()
      .oneOf([1, 2, 3], "Gender must be 1 (Male), 2 (Female), or 3 (Unisex)")
      .required("This field is required"),
    female_image: yup
      .mixed()
      .test("required", "This field is required", function (value) {
        if (flag) {
          return true;
        }
        return value != null;
      }),
    position: yup
      .number()
      .required("This field is required")
      .typeError("This field is required"),
    status: yup
      .number()
      .oneOf(
        [1, 2, 3, 4],
        "Status must be 1 (Active), 2 (Inactive), 3 (Blocked), or 4 (Deleted)"
      )
      .required("This field is required"),
    home_view: yup.string().required("This field is required"),
  });

export const addcategary2 = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    gender: yup
      .number()
      .oneOf([1, 2, 3], "Gender must be 1 (Male), 2 (Female), or 3 (Unisex)")
      .required("This field is required"),
    male_image: yup
      .mixed()
      .test("required", "This field is required", function (value) {
        if (flag) {
          return true;
        }
        return value != null;
      }),
    female_image: yup
      .mixed()
      .test("required", "This field is required", function (value) {
        if (flag) {
          return true;
        }
        return value != null;
      }),
    position: yup
      .number()
      .required("This field is required")
      .typeError("This field is required"),
    status: yup
      .number()
      .oneOf(
        [1, 2, 3, 4],
        "Status must be 1 (Active), 2 (Inactive), 3 (Blocked), or 4 (Deleted)"
      )
      .required("This field is required"),
    home_view: yup.string().required("This field is required"),
  });

export const addsubcategary = (flag) =>
  yup.object({
    category_id: yup
      .number()
      .required("This Field is required")
      .typeError("This Field is required"),
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    gender: yup
      .number()
      .oneOf([1, 2, 3], "Gender must be 1 (Male), 2 (Female), or 3 (Unisex)")
      .required("This field is required"),
    status: yup
      .number()
      .oneOf(
        [1, 2, 3, 4],
        "Status must be 1 (Active), 2 (Inactive), 3 (Blocked), or 4 (Deleted)"
      )
      .required("This field is required"),
  });

export const addbusiness = (flag) =>
  yup.object({
    business_name: yup.string().required("This Field is required"),
    gender: yup.string().required("This Field is required"),
    email_id: yup
      .string()
      .email("This Field is required")
      .required("This Field is required"),
    country_code: yup.string().required("This Field is required"),
    mobile_number: yup
      .string()
      .matches(/^[0-9]+$/, "This Field is required")
      .required("This Field is required"),
    address: yup.string().required("This Field is required"),
    website: yup
      .string()
      .test("is-url-valid", "This Field is required", (value) => {
        if (!value) return false;
        return /^(https?:\/\/)?(www\.)?[\w-]+(\.[\w-]+)+$/.test(value);
      })
      .required("This Field is required"),
    cr_number: yup
      .string()
      .trim()
      .required("This Field is Required")
      .matches(/^\d{10}$/, "Please enter a valid 10-digit number"),
    // logo: yup.mixed().required('This Field is required'),
    first_name: yup.string().required("This Field is required"),
    last_name: yup.string().required("This Field is required"),
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .required("This Field is required"),
    logo: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Supported formats are .jpg, .png, .svg", (value) => {
        if (!value) return false;
        const acceptedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
        return acceptedFormats.includes(value.type);
      }),
  });

export const update_business = (flag) =>
  yup.object({
    business_name: yup.string().required("This Field is required"),
    gender: yup.string().required("This Field is required"),
    email_id: yup
      .string()
      .email("enter a Valid mail address")
      .test("email-validation", "enter a Valid mail address", (value) => {
        if (!value) return false;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    country_code: yup.string().required("This Field is required"),
    hours: yup
      .array()
      .test(
        "hours",
        "Please Select Opening  time and Closing time",
        function (value) {
          if (!value || !Array.isArray(value)) return true;
          return !value.some(
            (slot) => !slot.opening_time || !slot.closing_time
          );
        }
      ),
    mobile_number: yup
      .string()
      .min(9, "minimum number")
      .max(10, "Maximum of 10 number you can use")
      .required("mobile number is required"),

    address: yup.string().required("This Field is required"),
    website: yup.string().matches(
      // /^(https?:\/\/)?(www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+([\/\w .-]*)*\/?$/,
      "Enter a valid website URL"
    ),
    cr_number: yup
      .string()
      .trim()
      .required("This Field is Required")
      .matches(/^\d{10}$/, "Please enter a valid 10-digit number"),
    first_name: yup.string().required("This Field is required"),
    last_name: yup.string().required("This Field is required"),
  });

export const BusinessPasswordUpdate = (flag) =>
  yup.object({
    business_name: yup.string().required("This Field is required"),
    gender: yup.string().required("This Field is required"),
    email_id: yup
      .string()
      .email("enter a Valid mail address")
      .test("email-validation", "enter a Valid mail address", (value) => {
        if (!value) return false;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    country_code: yup.string().required("This Field is required"),
    hours: yup
      .array()
      .test(
        "hours",
        "Please Select Opening  time and Closing time",
        function (value) {
          if (!value || !Array.isArray(value)) return true;
          return !value.some(
            (slot) => !slot.opening_time || !slot.closing_time
          );
        }
      ),
    mobile_number: yup
      .string()
      .min(9, "minimum number")
      .max(10, "Maximum of 10 number you can use")
      .required("mobile number is required"),

    address: yup.string().required("This Field is required"),
    website: yup.string().matches(
      // /^(https?:\/\/)?(www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+([\/\w .-]*)*\/?$/,
      "Enter a valid website URL"
    ),
    cr_number: yup
      .string()
      .trim()
      .required("This Field is Required")
      .matches(/^\d{10}$/, "Please enter a valid 10-digit number"),
    first_name: yup.string().required("This Field is required"),
    last_name: yup.string().required("This Field is required"),
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .required("This Field is required"),
  });

export const addadmin = (update) =>
  yup.object({
    first_name: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    company_vat_number: yup
      .string()
      .required("This field is required")
      .min(15, "Enter minimum 15 characters")
      .max(15, "Enter maximum 15 characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0
      ),
    last_name: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    mobile_number: yup
      .string()
      .min(9, "Minimum of 9 digits should be there")
      .max(10, "Maximum of 10 numbers")
      .required("mobile number is required"),
    email_id: yup
      .string()
      .email("Enter a valid email address")
      .test(
        "optional-email-validation",
        "Enter a valid email address",
        (value) =>
          !value ||
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
      ),
    company_registration_number: yup
      .string()
      .required("This field is required")
      .min(9, "Enter minimum 9 characters")
      .max(15, "Enter maximum 15 characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0
      ),
    // address: yup.string().required("This Field is required"),
    // category_id: yup.string().required("This Field is required"),
    // company_cr: yup.string().required("Company certificate is required"),
    // vat_certificate: yup.string().required("Vat certificate is required"),
    // company_name: yup
    //   .string()
    //   .required("This field is required")
    //   .min(2, "Enter at least two character")
    //   .test(
    //     "not-only-spaces",
    //     "Please enter a valid value",
    //     (value) => value && value.trim().length > 0
    //   ),
    // company_services: yup
    //   .string()
    //   .required("This field is required")
    //   .min(2, "Enter at least two character")
    //   .test(
    //     "not-only-spaces",
    //     "Please enter a valid value",
    //     (value) => value && value.trim().length > 0
    //   ),
    // company_registration_number: yup
    //   .string()
    //   .required("This field is required")
    //   .min(2, "Enter at least two character")
    //   .test(
    //     "not-only-spaces",
    //     "Please enter a valid value",
    //     (value) => value && value.trim().length > 0
    //   ),
  });
export const updateadmin = () =>
  yup.object({
    first_name: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    last_name: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    mobile_number: yup
      .string()
      .matches(/^\d+$/, "Mobile number must contain digits only")
      .required("mobile number is required"),
    email_id: yup
      .string()
      .email("Enter a valid email address")
      .test(
        "optional-email-validation",
        "Enter a valid email address",
        (value) =>
          !value ||
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
      ),
    company_registration_number: yup.string().nullable(),
    company_vat_number: yup
      .string()
      .nullable()
      .test(
        "optional-saudi-vat-validation",
        "VAT number must be 15 digits and start and end with 3",
        (value) => !value || /^3\d{13}3$/.test(value.trim())
      ),
  });

export const updateCustomer = () =>
  yup.object({
    first_name: yup
      .string()
      .nullable()
      .test(
        "optional-not-only-spaces",
        "Please enter a valid value",
        (value) => !value || value.trim() !== ""
      ),
    last_name: yup
      .string()
      .nullable()
      .test(
        "optional-not-only-spaces",
        "Please enter a valid value",
        (value) => !value || value.trim() !== ""
      ),
    mobile_number: yup
      .string()
      .nullable()
      .test(
        "optional-digits-only",
        "Mobile number must contain digits only",
        (value) => !value || /^\d+$/.test(value)
      ),
    email_id: yup
      .string()
      .email("Enter a valid email address")
      .test(
        "optional-email-validation",
        "Enter a valid email address",
        (value) =>
          !value ||
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
      ),
    company_registration_number: yup.string().nullable(),
    company_vat_number: yup
      .string()
      .nullable()
      .test(
        "optional-saudi-vat-validation",
        "VAT number must be 15 digits and start and end with 3",
        (value) => !value || /^3\d{13}3$/.test(value.trim())
      ),
    password: yup
      .string()
      .nullable()
      .test(
        "optional-password-length",
        "Password must be at least 6 characters",
        (value) => !value || value.length >= 6
      ),
  });

export const addadminWithPassword = (update) =>
  yup.object({
    first_name: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    company_vat_number: yup
      .string()
      .required("This field is required")
      .min(15, "Enter minimum 15 characters")
      .max(15, "Enter maximum 15 characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0
      ),
    last_name: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    mobile_number: yup
      .string()
      .min(9, "Minimum of 9 digits should be there")
      .max(10, "Maximum of 10 numbers")
      .required("mobile number is required"),
    email_id: yup
      .string()
      .email("Enter a valid email address")
      .test(
        "optional-email-validation",
        "Enter a valid email address",
        (value) =>
          !value ||
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
      ),
    company_registration_number: yup
      .string()
      .required("This field is required")
      .min(9, "Enter minimum 9 characters")
      .max(15, "Enter maximum 15 characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0
      ),
    password: yup.string()
      .trim()
      .required('Password is required')
      .min(8, 'Password must be at least 8 characters long')
      .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
      .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
      .matches(/[0-9]/, 'Password must contain at least one number')
      .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character'),

  });

export const hoursValidationSchema = yup.array().of(
  yup.object().shape({
    day: yup.number().required(),
    opening_time: yup
      .string()
      .test(
        "unique-time",
        "Duplicate shift times are not allowed on the same day",
        function (value, context) {
          const { hours } = this.options.context;
          const currentHour = context.parent;
          const duplicate = hours.filter(
            (h) =>
              h.day === currentHour.day &&
              h.opening_time === value &&
              h !== currentHour
          );
          return duplicate.length === 0;
        }
      )
      .required("This Field is required"),
    closing_time: yup.string().required("This Field is required"),
  })
);

export const adddriver = (flag) =>
  yup.object({
    email_id: yup
      .string()
      .email("enter a Valid mail address")
      .test("email-validation", "enter a Valid mail address", (value) => {
        if (!value) return false;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    country_code: yup.string().required("This Field is required"),
    mobile_number: yup
      .string()
      .min(9, "Minimum of 9 digits should be there")
      .max(10, "Maximum of 10 numbers")
      .required("mobile number is required"),

    first_name: yup.string().required("This Field is required"),
    last_name: yup.string().required("This Field is required"),
    car_model: yup.string().required("This Field is required"),
    car_color: yup.string().required("This Field is required"),
    car_number: yup.string().required("This Field is required"),
    nationality: yup.string().required("This Field is required"),
    national_id: yup.string().required("This Field is required"),
    license_back: yup.mixed().required("Image is required"),
    license_front: yup.mixed().required("Image is required"),
    car_registration_front: yup.mixed().required("Image is required"),
    car_registration_back: yup.mixed().required("Image is required"),
  });

export const addoffer = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),
    coupon_code: yup.string().required("This Field is required"),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
    arabic_banner: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Supported formats are .jpg, .png, .svg", (value) => {
        if (!value) return false;
        const acceptedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
        return acceptedFormats.includes(value.type);
      }),
    english_banner: yup
      .mixed()
      .required("Image is required")
      .test("fileFormat", "Supported formats are .jpg, .png, .svg", (value) => {
        if (!value) return false;
        const acceptedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
        return acceptedFormats.includes(value.type);
      }),
  });

export const home_addoffer = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),
    coupon_code: yup.string().required("This Field is required"),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
  });

export const InstantCode = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),

    coupon_code: yup.string(),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
    arabic_banner: yup.mixed().required("Image is required"),

    english_banner: yup.mixed().required("Image is required"),
  });

export const home_InstantCode = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),

    coupon_code: yup.string(),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
  });
export const add_offers_update = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),
    coupon_code: yup.string().required("This Field is required"),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup.number().required('This Field is required').positive('This Field is required'),
    //   minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
    arabic_banner: yup.mixed().required("Image is required"),

    english_banner: yup.mixed().required("Image is required"),
  });

export const home_add_offers_update = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    ar_title: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    start_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    end_date: yup
      .date()
      .required("This Field is required")
      .typeError("This Field is required"),
    offer_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "This Field is required"),
    coupon_code: yup.string().required("This Field is required"),
    limit_per_client: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    no_of_usage: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required")
      .integer("This Field is required"),
    // minimum_amount: yup.number().required('This Field is required').positive('This Field is required'),
    //   minimum_amount: yup
    // .number()
    // .required("This Field is required")
    // .min(0, "This Field is required"),

    price_type: yup
      .number()
      .required("This Field is required")
      .oneOf([1, 2], "Invalid Price Type"),
    home_view: yup
      .number()
      .required("This Field is required")
      .oneOf([0, 1], "This Field is required"),
    offer_value: yup
      .number()
      .required("This Field is required")
      .positive("This Field is required"),
  });

export const deliveryCharges = (flag) => yup.object({});

export const addMembershipValidation = (flag) =>
  yup.object({
    title: yup
      .string()
      // .matches(/^[A-Za-z0-9\s]+$/, "Title must contain only letters, numbers, and spaces")
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    ar_title: yup
      .string()
      // .matches(/^[A-Za-z0-9\s]+$/, "Ar Title must contain only letters, numbers, and spaces")
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    max_invoices: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Simplified invoices must be a valid number")
      .test("isValidNumber", "Simplified invoices must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Simplified invoices cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices1: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "VAT invoices must be a valid number")
      .test("isValidNumber", "VAT invoices must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "VAT invoices cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices2: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Purchase invoices must be a valid number")
      .test("isValidNumber", "Purchase invoices must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Purchase invoices cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices3: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Credit notes must be a valid number")
      .test("isValidNumber", "Credit notes must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Credit notes cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices4: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Debit Note must be a valid number")
      .test("isValidNumber", "Debit Note must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Debit Note cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    duration: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Duration must be a valid number without special characters")
      .test("isValidNumber", "Duration must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Duration cannot be negative")
      .required("Duration is required"),
    price: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Price must be a valid number without special characters")
      .test("isValidNumber", "Price must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Price cannot be negative")
      .required("Price is required"),
    dollar_price: yup
      .string()
      .test(
        "isValidDollarPrice",
        "Shopify price must be a valid number without special characters",
        (value) => value === undefined || value === "" || /^\d+(\.\d{1,2})?$/.test(value)
      )
      .test(
        "isPositiveDollarPrice",
        "Shopify price cannot be negative",
        (value) => value === undefined || value === "" || Number(value) >= 0
      ),
    discount: yup
      .string()
      .matches(/^\d{1,3}(\.\d{1,2})?$/, "Discount must be a valid number between 0 and 100, without special characters")
      // .test("isValidNumber", "Discount must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Discount cannot be negative"),
    status: yup
      .number()
      .nullable()
      .transform((value, originalValue) => (originalValue === "" ? null : value))
      .oneOf([1, 2], "Status must be either Active or Inactive"),
    duration_type: yup
      .number()
      .oneOf([1, 2, 3], "Duration must be either 1 or 2, or 3")
      .required("Duration type  is required"),
  });

export const addtopValidation = (flag) =>
  yup.object({
    title: yup
      .string()
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    ar_title: yup
      .string()
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    max_invoices: yup
      .number()
      .typeError("Max invoices must be a number")
      .integer("Max invoices must be an integer")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices1: yup
      .number()
      .typeError("Max invoices must be a number")
      .integer("Max invoices must be an integer")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices2: yup
      .number()
      .typeError("Max invoices must be a number")
      .integer("Max invoices must be an integer")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    status: yup
      .number()
      .required("status is required"),
    price: yup
      .number()
      .typeError("Price must be a number")
      .min(0, "Price must be 0 or greater")
      .required("Price is required"),
  });

export const trialInfo = (flag) => yup.object({
  max_invoices: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Simplified invoices must be a valid number")
    .test("isValidNumber", "Simplified invoices must be a number", (value) => value !== undefined && !isNaN(value))
    .min(0, "Simplified invoices cannot be negative")
    .when([], {
      is: () => flag !== true, // Allows bypassing validation when flag is true
      then: (schema) => schema.required("This field is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  max_invoices1: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "VAT invoices must be a valid number")
    .test("isValidNumber", "VAT invoices must be a number", (value) => value !== undefined && !isNaN(value))
    .min(0, "VAT invoices cannot be negative")
    .when([], {
      is: () => flag !== true, // Allows bypassing validation when flag is true
      then: (schema) => schema.required("This field is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  max_invoices2: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Purchase invoices must be a valid number")
    .test("isValidNumber", "Purchase invoices must be a number", (value) => value !== undefined && !isNaN(value))
    .min(0, "Purchase invoices cannot be negative")
    .when([], {
      is: () => flag !== true, // Allows bypassing validation when flag is true
      then: (schema) => schema.required("This field is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  duration: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Duration must be a valid number without special characters")
    .test("isValidNumber", "Duration must be a number", (value) => value !== undefined && !isNaN(value))
    .min(0, "Duration cannot be negative")
    .required("Duration is required"),
  duration_type: yup
    .number()
    .oneOf([1, 2, 3], "Duration must be either 1 or 2, or 3")
    .required("Duration type  is required"),
});
export const discountaAddMembershipValidation = (flag) =>
  yup.object({
    title: yup
      .string()
      // .matches(/^[A-Za-z0-9\s]+$/, "Title must contain only letters, numbers, and spaces")
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    ar_title: yup
      .string()
      // .matches(/^[A-Za-z0-9\s]+$/, "Ar Title must contain only letters, numbers, and spaces")
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    // max_invoices: yup
    //   .number()
    //   .typeError('Max invoices must be a number')
    //   .positive('Max invoices must be a positive number')
    //   .integer('Max invoices must be an integer')
    //   .required('This field is required'),
    max_invoices: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Simplified invoices must be a valid number")
      .test("isValidNumber", "Simplified invoices must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Simplified invoices cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices1: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "VAT invoices must be a valid number")
      .test("isValidNumber", "VAT invoices must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "VAT invoices cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices2: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Purchase invoices must be a valid number")
      .test("isValidNumber", "Purchase invoices must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Purchase invoices cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices3: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Credit notes must be a valid number")
      .test("isValidNumber", "Credit notes must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Credit notes cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    max_invoices4: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Debit Note must be a valid number")
      .test("isValidNumber", "Debit Note must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Debit Note cannot be negative")
      .when([], {
        is: () => flag !== true, // Allows bypassing validation when flag is true
        then: (schema) => schema.required("This field is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    duration: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Duration must be a valid number without special characters")
      .test("isValidNumber", "Duration must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Duration cannot be negative")
      .required("Duration is required"),
    price: yup
      .string()
      .matches(/^\d+(\.\d{1,2})?$/, "Price must be a valid number without special characters")
      .test("isValidNumber", "Price must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Price cannot be negative")
      .required("Price is required"),
    discount: yup
      .string()
      .matches(/^\d{1,3}(\.\d{1,2})?$/, "Discount must be a valid number between 0 and 100, without special characters")
      // .test("isValidNumber", "Discount must be a number", (value) => value !== undefined && !isNaN(value))
      .min(0, "Discount cannot be negative"),
    duration_type: yup
      .number()
      .oneOf([1, 2, 3], "Duration must be either 1 or 2, or 3")
      .required("Duration type  is required"),
  });

export const addInvoicesValidation = (flag) =>
  yup.object({
    user_id: yup.string().required("Customer name is required"),
    invoice_type: yup
      .number()
      .oneOf([0, 1, 2], "Invoice type must be 0, 1, or 2")
      .required("Invoice type is required"),
    client_id: yup
      .string()
      .nullable()
      .when("invoice_type", (invoiceType, schema) => {
        if (Number(invoiceType) === 1 || Number(invoiceType) === 2) {
          return schema.required("Client is required");
        }
        return schema.notRequired();
      }),
    reference_number: yup
      .string()
      .min(1, "title must be at least 1 characters")
      .required("Reference is required"),
    footer_text: yup
      .string()
      .required("Terms and conditions is required"),
    notes: yup
      .string()
      .required("Message is required"),
    invoice_detail: yup
      .array()
      .of(
        yup.object().shape({
          description: yup
            .string()
            .required("Description is required"),
          unit_price: yup
            .number()
            .typeError("Unit price must be a number")
            .required("Unit price is required"),
          quantity: yup
            .number()
            .typeError("Quantity must be a number")
            .min(1, "Quantity must be at least 1")
            .required("Quantity is required"),
          vat_percent: yup
            .string()
            .matches(/^\d{1,3}(\.\d{1,2})?$/, "VAT must be a valid number between 0 and 100, without special characters")
            .test("isValidNumber", "VAT must be a number", (value) => value !== undefined && !isNaN(value))
            .max(100, "VAT cannot exceed 100%")
            .min(0, "VAT cannot be negative")
            .required("VAT is required"),

          discount_percent: yup
            .string()
            .matches(/^\d{1,3}(\.\d{1,2})?$/, "Discount must be a valid number between 0 and 100, without special characters")
            .test("isValidNumber", "Discount must be a number", (value) => value !== undefined && !isNaN(value))
            .max(100, 'Discount cannot exceed 100%')
            .min(0, "Discount cannot be negative"),

          product_id: yup
            .string()
            .required("Product id  is required"),
        })
      )
      .min(1, "At least one invoice detail is required"),
    logo: yup.string().required("Logo is required"),
    date_time: yup.string().required("this  is required"),
    // time: yup.string().required("time is required"),
    // date_time: yup.string()
    //   .required('Date and time are required')
    //   .test('datetime-format', 'Invalid date time format', (value) => {
    //       if (!value) return false;
    //       // Check if the value matches the expected format "YYYY-MM-DD HH:mm:ss"
    //       return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value);
    //   }),
  });


export const addCreditNOteValidation = (flag) =>
  yup.object({
    user_id: yup.string().required("Customer name is required"),
    parent_invoice_number: yup.string().required("Original invoice is required"),
    client_id: yup
      .string()
      .required("Client is required"),
    reference_number: yup
      .string()
      .min(1, "title must be at least 1 characters")
      .required("Reference is required"),
    footer_text: yup
      .string()
      .required("Terms and conditions is required"),
    notes: yup
      .string()
      .required("Message is required"),
    invoice_detail: yup
      .array()
      .of(
        yup.object().shape({
          description: yup
            .string()
            .required("Description is required"),
          unit_price: yup
            .number()
            .typeError("Unit price must be a number")
            .required("Unit price is required"),
          quantity: yup
            .number()
            .typeError("Quantity must be a number")
            .min(1, "Quantity must be at least 1")
            .required("Quantity is required"),
          vat_percent: yup
            .string()
            .matches(/^\d{1,3}(\.\d{1,2})?$/, "VAT must be a valid number between 0 and 100, without special characters")
            .test("isValidNumber", "VAT must be a number", (value) => value !== undefined && !isNaN(value))
            .max(100, "VAT cannot exceed 100%")
            .min(0, "VAT cannot be negative")
            .required("VAT is required"),

          discount_percent: yup
            .string()
            .matches(/^\d{1,3}(\.\d{1,2})?$/, "Discount must be a valid number between 0 and 100, without special characters")
            .max(100, 'Discount cannot exceed 100%')
            .min(0, "Discount cannot be negative"),

          product_id: yup
            .string()
            .required("Product id  is required"),
        })
      )
      .min(1, "At least one invoice detail is required"),
    logo: yup.string().required("Logo is required"),
    date_time: yup.string().required("date is required"),
    time: yup.string().required("time is required"),
    // date_time: yup.string()
    //   .required('Date and time are required')
    //   .test('datetime-format', 'Invalid date time format', (value) => {
    //       if (!value) return false;
    //       // Check if the value matches the expected format "YYYY-MM-DD HH:mm:ss"
    //       return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value);
    //   }),
  });

export const settingsUpdateValidation = (flag) =>
  yup.object({
    referral_duration: yup
      .number()
      .typeError("Duration must be a number")
      .positive("Duration must be a positive number")
      .required("This field is required"),
    referral_duration_type: yup
      .number()
      .oneOf([1, 2, 3, 4], "Must select this filed")
      .required("Duration  type  is required"),
    referral_percentage: yup
      .number()
      .typeError("Must be a number")
      .positive("Must be a positive number")
      .required("This field is required"),
  });

export const invoiceVatValidation = () =>
  yup.object({
    vat_percent: yup
      .number()
      .max(100, "VAT cannot exceed 100%")
      .typeError("VAT must be a number")
      .positive("VAT must be a positive number")
      .required("VAT is required"),

    company_registration_number: yup
      .string()
      .min(9, "Company registration number must be at least 9 digits")
      .max(15, "Company registration number must be at most 15 digits")
      .required("Company registration number is required"),
    free_invoice_count: yup
      .string()
      .required("Free invoice count is required"),

    company_vat_number: yup
      .string()
      .min(15, "Company VAT number must be at least 15 digits")
      .max(15, "Company VAT number must be at most 15 digits")
      .required("Company VAT number is required"),

    company_name: yup
      .string()
      .required("Company name is required"),

  });

export const contactInfoValidation = (flag) =>
  yup.object({
    mobile: yup
      .string()
      .min(9, "Minimum 9 digits required")
      .max(10, "Maximum 10 digits allowed")
      .required("Mobile number is required"),

    email: yup
      .string()
      .email("Enter a valid email address")
      .test("email-validation", "Enter a valid email address", (value) => {
        if (!value) return false;
        const emailRegex =
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),

    facebook: yup
      .string()
      .url("Enter a valid TikTok URL")
      .nullable(),

    linkedin: yup
      .string()
      .url("Enter a valid WhatsApp URL")
      .nullable(),

    instagram: yup
      .string()
      .url("Enter a valid Instagram URL")
      .nullable(),

    x: yup
      .string()
      .url("Enter a valid X (Twitter) URL")
      .nullable(),
  });

export const WebHookUrlSigned = (flag) =>
  yup.object({
    sign_webhook_url: yup
      .string()
      .url("Enter a valid sign webhook URL")
      .nullable(),


  });


export const termsAndConditionValidation = () =>
  yup.object({
    terms: yup
      .string()
      .required("Terms and Condtions are required"),
    ar_terms: yup
      .string()
      .required("Terms and Condtions are required"),
  });
export const customerMembershipValidation = (flag) =>
  yup.object({
    start_date: yup
      .date()
      .required("Start date is required"),
    user_id: yup.string().required("This Field is required"),
    membership_id: yup.string().required("This Field is required"),
  });

export const addClientValidation = (flag) =>
  yup.object({
    first_name: yup
      .string()
      .required("This field is required")
      .min(2, "Enter at least two characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0
      ),
    company_registration_number: yup.string().required("This Field is required"),
    company_vat_number: yup.string().required("This Field is required"),

    category_id: yup.string().required("This Field is required"),
    client_type: yup
      .number()
      .oneOf([1, 2], "client type  must be either 1 or 2")
      .required("client type  is required"),
    // last_name: yup
    //   .string()
    //   .required("This field is required")
    //   .min(2, "Enter at least two characters")
    //   .test(
    //     "not-only-spaces",
    //     "Please enter a valid value",
    //     (value) => value && value.trim().length > 0
    //   ),
    street_name: yup
      .string()
      .required("Street name is Required*"),
    building_number: yup
      .number()
      .typeError("Building number must be a number")
      .test(
        "len",
        "Building number must contain at least 4 digits",
        (val) => val && val.toString().length >= 4
      )
      .required("Building number is Required*"),

    city: yup
      .string()
      .required("City is Required*"),
    postal_code: yup
      .string()
      .min(5, 'Postal code must contain 5 digits')
      .required("Postal code is Required*"),
    district: yup
      .string()
      .required("District is Required*"),
    email_id: yup
      .string()
      .email("enter a Valid mail address")
      .test("email-validation", "enter a Valid mail address", (value) => {
        if (!value) return false;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    mobile_number: yup
      .string()
      .min(9, "minimum number")
      .max(10, "Maximum of 10 number you can use")
      .required("mobile number is required"),
  });
export const addIndiClientValidation = (flag) =>
  yup.object({
    first_name: yup
      .string()
      .required("This field is required")
      .min(2, "Enter at least two characters")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0
      ),
    company_registration_number: yup.string(),
    company_vat_number: yup.string(),

    category_id: yup.string(),
    client_type: yup
      .number()
      .oneOf([1, 2], "client type  must be either 1 or 2")
      .required("client type  is required"),
    // last_name: yup
    //   .string()
    //   .required("This field is required")
    //   .min(2, "Enter at least two characters")
    //   .test(
    //     "not-only-spaces",
    //     "Please enter a valid value",
    //     (value) => value && value.trim().length > 0
    //   ),
    street_name: yup
      .string(),
    building_number: yup
      .number()
      .typeError("Building number must be a number"),

    city: yup
      .string(),
    postal_code: yup
      .string()
      .min(5, 'Postal code must contain 5 digits'),
    district: yup
      .string(),
    email_id: yup
      .string()
      .email("enter a Valid mail address")
      .test("email-validation", "enter a Valid mail address", (value) => {
        if (!value) return false;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    mobile_number: yup
      .string()
      .min(9, "minimum number")
      .max(10, "Maximum of 10 number you can use")
      .required("mobile number is required"),
  });

export const addCatagoriesValidation = (flag) =>
  yup.object({
    title: yup
      .string()
      .min(3, "Title must be at least 3 characters")
      .required("Title is required"),
    ar_title: yup
      .string()
      .min(3, "Ar title must be at least 3 characters")
      .required("Ar title is required"),
    position: yup
      .number()
      // .oneOf([1, 2, 3], "Position must be either 1 or 2 or 3")
      .required("Position is required"),

    status: yup
      .number()
      // .oneOf([1, 2], "Status must be either 1 or 2")
      .required("Status type  is required"),
  });

export const createTicketValidation = (flag) =>
  yup.object({
    title: yup
      .string()
      .required("Title is required"),
    ar_title: yup
      .string()
      .required("Ar title is required"),
    position: yup
      .number()
      .required("Position is required"),
    status: yup
      .number()
      // .oneOf([1, 2], "Status must be either 1 or 2")
      .required("Status type  is required"),
  });

export const addServiceValidation = (flag) =>
  yup.object({
    title: yup
      .string()
      .min(3, "Title must be at least 3 characters")
      .required("Title is required"),
    ar_title: yup
      .string()
      .min(3, "Ar title must be at least 3 characters")
      .required("Ar title is required"),
    position: yup
      .number()
      // .oneOf([1, 2, 3], "Position must be either 1 or 2 or 3")
      .required("Position is required"),

    status: yup
      .number()
      // .oneOf([1, 2], "Status must be either 1 or 2")
      .required("Status type  is required"),
    category_id: yup.string().required("This Field is required"),
  });


export const section1Validation = (flag) =>
  yup.object({
    image: yup.string().required("image is required"),
    title: yup
      .string()
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    sub_title: yup
      .string()
      .min(2, "sub title must be at least 2 characters")
      .required("sub title is required"),
    ar_title: yup
      .string()
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    ar_sub_title: yup
      .string()
      .min(2, "ar sub title must be at least 2 characters")
      .required("ar sub title  is required"),

  });

export const seoHomeValidation = (flag) =>
  yup.object({

    h1: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("h1 is required"),
    h2: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("h2 is required"),
    ar_h2: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("ar h2  is required"),
    ar_h1: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("ar h1  is required"),
    canonical: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("canonical  is required"),
    ar_canonical: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("ar canonical  is required"),
    ar_meta_description: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("ar meta description  is required"),
    meta_description: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("meta description  is required"),
    meta_title: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("meta title is required"),
    ar_meta_title: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("ar meta title is required"),
    keywords: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("keywords are required"),
    ar_keywords: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("ar keywords are required"),





  });

export const seoTagManager = (flag) =>
  yup.object({

    body: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("body is required"),
    header: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("header is required"),
    title: yup
      .string()
      .min(2, "Enter at least 2 characters")
      .required("title  is required"),

  });

export const section3Validation = (flag) =>
  yup.object({
    image: yup.string().required("image is required"),
    icon: yup.string().required("Icon is required"),
    title: yup
      .string()
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    sub_title: yup
      .string()
      .min(2, "sub title must be at least 2 characters")
      .required("sub title is required"),
    description: yup
      .string()
      .min(5, "description  must be at least 5 characters")
      .required("description is required"),
    ar_description: yup
      .string()
      .min(5, "ar description  must be at least 5 characters")
      .required("ar description is required"),
    ar_title: yup
      .string()
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    ar_sub_title: yup
      .string()
      .min(2, "ar sub title must be at least 2 characters")
      .required("ar sub title  is required"),

  });

export const sectionValidationImages = (flag) =>
  yup.object({
    image: yup.string().required("image is required"),
    // icon: yup.string().required("Icon is required"),
    title: yup
      .string()
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    sub_title: yup
      .string()
      .min(2, "sub title must be at least 2 characters")
      .required("sub title is required"),
    description: yup
      .string()
      .min(5, "description  must be at least 5 characters")
      .required("description is required"),
    ar_description: yup
      .string()
      .min(5, "ar description  must be at least 5 characters")
      .required("ar description is required"),
    ar_title: yup
      .string()
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    ar_sub_title: yup
      .string()
      .min(2, "ar sub title must be at least 2 characters")
      .required("ar sub title  is required"),

  });

export const sectionValidationReq = (flag) =>
  yup.object({
    image: yup.string().required("image is required"),
    title: yup
      .string()
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    sub_title: yup
      .string()
      .min(2, "sub title must be at least 2 characters")
      .required("sub title is required"),
    description: yup
      .string()
      .min(5, "description  must be at least 5 characters")
      .required("description is required"),
    ar_description: yup
      .string()
      .min(5, "ar description  must be at least 5 characters")
      .required("ar description is required"),
    ar_title: yup
      .string()
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    ar_sub_title: yup
      .string()
      .min(2, "ar sub title must be at least 2 characters")
      .required("ar sub title  is required"),

  });

export const section5Validation = (flag) =>
  yup.object({
    title: yup
      .string()
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    image: yup.string().required("image is required"),
    sub_title: yup
      .string()
      .min(2, "sub title must be at least 2 characters")
      .required("sub title is required"),
    description: yup
      .string()
      .min(5, "description  must be at least 5 characters")
      .required("description is required"),
    ar_description: yup
      .string()
      .min(5, "ar description  must be at least 5 characters")
      .required("ar description is required"),
    ar_title: yup
      .string()
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    ar_sub_title: yup
      .string()
      .min(2, "ar sub title must be at least 2 characters")
      .required("ar sub title  is required"),

  });

export const section6Validation = (flag) =>
  yup.object({
    // image: yup.string().required("image is required"),
    title: yup
      .string()
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    sub_title: yup
      .string()
      .min(2, "sub title must be at least 2 characters")
      .required("sub title is required"),
    ar_title: yup
      .string()
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    ar_sub_title: yup
      .string()
      .min(2, "ar sub title must be at least 2 characters")
      .required("ar sub title  is required"),

  });

export const section2Validation = (flag) =>
  yup.object({
    icon: yup.string().required("image is required"),
    position: yup
      .number()
      // .oneOf([1, 2, 3, 4, 5, 6], "Position is required")
      .required("Position is required"),


  });
export const ZatcaSubmitvalidation = () => yup.object({

  organization_identifier: yup
    .string()
    .required("Organization identifier is Required*"),
  // .min(15, "15 digits are required"),
  organization_unit_name: yup
    .string()
    .required("Company branch name is Required*"),
  organization_name: yup
    .string()
    .required("Company name is Required*"),
  // invoice_type: yup
  //     .string()
  //     .required("Invoice type is Required*"),
  industry_business_category: yup
    .string()
    .required("Business category is Required*"),
  street_name: yup
    .string()
    .required("Street name is Required*"),
  building_number: yup
    .number()
    .typeError("Building number must be a number")
    .test(
      "len",
      "Building number must contain at least 4 digits",
      (val) => val && val.toString().length >= 4
    )
    .required("Building number is Required*"),

  city: yup
    .string()
    .required("City is Required*"),
  postal_code: yup
    .string()
    .min(5, 'Postal code must contain 5 digits')
    .required("Postal code is Required*"),
  district: yup
    .string()
    .required("District is Required*"),

})

export const otpSubmission = () =>
  yup.object({
    otp: yup
      .string()
      .required("OTP is required*")
      .matches(/^\d{6}$/, "OTP must be exactly 6 digits"),
  });

export const section7Validation = (flag) =>
  yup.object({
    title: yup
      .string()
      .min(2, "title must be at least 2 characters")
      .required("title is required"),
    position: yup
      .number()
      // .oneOf([1, 2, 3, 4, 5, 6], "Position is required")
      .required("Position is required"),
    // image: yup.string().required("image is required"),
    sub_title: yup
      .string()
      .min(2, "sub title must be at least 2 characters")
      .required("sub title is required"),
    // description: yup
    // .string()
    // .min(5, "description  must be at least 5 characters")
    // .required("description is required"),
    // ar_description: yup
    // .string()
    // .min(5, "ar description  must be at least 5 characters")
    // .required("ar description is required"),
    ar_title: yup
      .string()
      .min(2, "ar title must be at least 2 characters")
      .required("ar title is required"),
    ar_sub_title: yup
      .string()
      .min(2, "ar sub title must be at least 2 characters")
      .required("ar sub title  is required"),

  });
